<template>
  <!-- 外发管理 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <!-- 合世版 先注释 -->
        <!-- <el-button v-if="hasPermiss('admin:outgoing_bill:addOutgoingBill')" class="glo_btnItems glo_bgcMainColor" @click="addBtns">新增</el-button> -->
        <el-button
          v-if="hasPermiss('admin:outgoing_bill:delOutgoingBill')"
          class="glo_btnItems"
          @click="delBtns()"
          >删除</el-button
        >
        <el-button class="glo_btnItems" @click="clickGZs">批量过账</el-button>
        <!-- <el-button class="glo_btnItems" @click="guoZhang()">过账</el-button> -->
        <el-button
          v-if="hasPermiss('admin:outgoing_bill:cancelPosting')"
          class="glo_btnItems"
          @click="fanGuoZhang()"
          >批量反过账</el-button
        >
        <!-- <el-button
          v-if="hasPermiss('admin:outgoing_bill:cancelPosting')"
          class="glo_btnItems"
          @click="getOnoTypeList()"
          >拉取轨迹数据</el-button
        > -->
        <el-button
          type="primary"
          class="glo_btnItems"
          @click="addOutgoing()"
          v-permission="'admin:pending:outgoing_order:add'"
        >
          新建外发
        </el-button>
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
            <el-dropdown-item command="print_btn">打印</el-dropdown-item>
            <!-- <el-dropdown-item command="dy_a">打印承运商结算单</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        :showMoreBtns="true"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="true"
      :isselection="true"
      :isShowMoreOperate="false"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="120"
      :showFilter="false"
    >
    </mytable>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 客户跟踪 -->
    <!-- <addCustomerTarck
      :showDia1="showDia1"
      :documentNumbers="documentNumbers"
      :documentStatus="documentStatus"
      :isdisabledStatus="true"
      @confirmAdd="confirmAdd"
      @closeDia1="closeDia1"
    ></addCustomerTarck>-->

    <!-- 拉取轨迹 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm"
          :model="dialogForm"
          label-width="100px"
        >
          <!-- <el-form-item class="dialogFormItems" prop="aaa" label="活动名称:">
            <el-input v-model="dialogForm.aaa"></el-input>
          </el-form-item> -->
          <el-form-item
            class="dialogFormItems"
            prop="confDictKey"
            label="第三方平台:"
          >
            <el-select v-model="dialogForm.confDictKey" placeholder="请选择" filterable>
              <el-option
                v-for="(itemA, idxA) in thirdApiPlatformList"
                :key="idxA"
                :label="itemA.descript"
                :value="itemA.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="onoType" label="类型:">
            <el-select v-model="dialogForm.onoType" placeholder="请选择" filterable>
              <el-option
                v-for="(itemA, idxA) in OnoTypeList"
                :key="idxA"
                :label="itemA.typeShow"
                :value="itemA.type"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item class="dislogFormTextarea" prop="ccc" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.ccc"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片:">
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="6"
            ></uploadimgs>
          </el-form-item> -->
        </el-form>
        <div v-if="tableDataA.length > 0">
          <el-table header-align="center" :data="tableDataA" border stripe>
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              label="外发单号"
              prop="number"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              width="220px"
            ></el-table-column>
            <el-table-column
              label="拉取结果"
              prop="msg"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
    <!-- *********************************打印 start ********************************* -->
    <!-- 选择打印模板 -->
    <printDialog
      :dialogFrom="dialogFrom"
      ref="dialogSelect"
      title="选择模板"
      icon="el-icon-printer"
      modelTypeVal="运单打印模板"
      @handleCreated="handleCreated"
      @handleView="handleView"
      @handleEdit="handleEdit"
      @handleOk="handleView"
    ></printDialog>

    <!-- 创建和使用模板 -->
    <printSys
      :printForm="printForm"
      :title="printTitle"
      icon="el-icon-printer"
      @handleClose="handlePrintSysClose"
    >
      <printSysContent
        :printType="printType"
        :modelObj="modelObj"
        :modelClassName="modelClassName"
        :selectTableData="selectTableData"
      ></printSysContent>
    </printSys>

    <!-- 打印系统数据接口的className -->
    <classNameDialog
      :diaWidth="classNameDiaWidth"
      :dialogTitle="classNameDialogTitle"
      :isShowDialog="isShowClassNameDialog"
      @handleCloseDia="handleCloseClassNameDia"
      @diaCancelBtn="classNameDiaCancelBtn"
      @diaConfirmBtn="classNameDiaConfirmBtn"
    >
      <el-select v-model="modelClassName" placeholder style="width: 100%" filterable>
        <el-option
          v-for="(value, key) in classNameArr"
          :key="key"
          :label="value.name"
          :value="value.val"
        ></el-option>
      </el-select>
    </classNameDialog>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import classNameDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
// import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import prints from "@/components/prints/print_waiFa.vue";
import printDialog from "@/components/printDialog/index.vue";
import printSys from "@/components/printSys/index.vue";
import printSysContent from "@/components/printSys/content.vue";
import { hiprint } from "@/print.js";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import jsPDF from "jspdf";
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import queryCondition from "@/components/queryCondition.vue";
import mytable from "@/components/table/table.vue";
export default {
  inject: ["reload"],
  mixins: [exportjs, tableListNew, mixin_print],
  components: {
    sorttable,
    paging,
    multitime,
    myDialog,
    uploadimgs,
    queryBtns,
    prints,
    printDialog,
    printSys,
    printSysContent,
    classNameDialog,
    queryCondition,
    mytable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "外发列表",
        //apiName: "/admin/v3/tms/waybill/outgoing/getOutgoingBillList", //导出的数据列表接口名
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        pageType: "OutgoingManage", //页面类型(主要用来区分查询参参数的时间)
      },
      //=======================导出相关 结束 =======================
      // 打印预览
      isShowDialog_print: false,
      diaWidth_print: "90%",
      dialogTitle_print: "打印预览",
      dataList: [],
      tableDataA: [],
      topData: {},

      changeCarrierList: [],
      storageList: [],
      //  -----  查询  ------
      queryData: {
        endCreateTime: "",
        endOutgoingTime: "",
        outboundCarrierId: "",
        outgoingNumber: "",
        startCreateTime: "",
        startDeptId: "",
        startOutgoingTime: "",
        waybillNumber: "",
        isPosting: 0,
        isExpense: "",
        settlementMethodConfDictId: "",
        sendEmployeeId: "",
        businessDeptId: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "外发创建日期",
        },
        {
          value: "1",
          label: "结束日期",
        },
        {
          value: "2",
          label: "运单提货日期",
        },
      ],
      timeType: "2", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据

      allCheck: false, //  全选
      sortName: "外发管理模板", //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "admin_outgoing_list_123213", //  页面标识
      reportFiledsNumber: "admin_outgoing_list", // 动态 条件、表头
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "WaybillEdit", //当前页面的方法
          param: 1, //自定义参数标记
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      // 新建客服跟踪
      showDia1: false,
      documentNumbers: "",
      documentStatus: "", //包裹单据

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "拉取轨迹数据",
      diaWidth: "60%",
      classNameDiaWidth: "300px",
      classNameDialogTitle: "请选择className",
      isShowClassNameDialog: false,
      dialogForm: {
        // 弹窗表单数据
        onoType: "",
        numbers: [],
        confDictKey: "",
      },
      rulesForm: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====

      rules: {
        aaa: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
      },

      // 打印模块
      // 打印弹出框
      dialogFrom: {
        dialogVisible: false,
      },
      // 创建新的打印
      printForm: {
        dialogVisible: false,
      },
      printTitle: "创建模板",
      printType: 1, // 1是创建 2是使用
      // 打印
      printDesignForm: {
        dialogVisible: false,
      },
      // 选择的模板数据
      modelObj: null,
      // 模板className
      classNameArr: [
        {
          name: "承运商结算单",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintDataV3tmsVo",
        },
        {
          name: "批量打印标签",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintBillDataV3tmsVo",
        },
      ],
      // 默认打印模板类型
      modelClassName:
        "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintDataV3tmsVo",
      // 下面是所有的模板类型
      modelClassName1:
        "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintDataV3tmsVo",
      modelClassName2:
        "com.bami.service.tms.v3.admin.print.vo.AdminOutgoingPrintBillDataV3tmsVo",

      yesOrNoList: [
        {
          name: "否",
          val: 0,
        },
        {
          name: "是",
          val: 1,
        },
      ],
      settlementMethodList: [],
      employeeList: [],
      businessDeptIdArr: [],
      CustomerLists: [],
      OnoTypeList: [],
      thirdApiPlatformList: [],
      // immediate: true,
    };
  },
  updated() {},
  created() {
    //this.getData();
  },
  activated() {
    // 每次进页面都会触发的写这里
    //计算获取表格高度
    // this.getData();
  },
  deactivated() {},
  mounted() {},
  watch: {},
  methods: {
    clickOutgoingTracking({
      outboundCarrierId,
      outboundCarrierName,
      number,
      outgoingId,
    }) {
      console.log(outgoingId);
      let query = {
        number,
        outboundCarrierId,
        outboundCarrierName,
        outgoingId,
      };
      this.$router.push({
        path: "/OutgoingManage/OutgoingTracking",
        query,
      });
    },
    clickGZs() {
      let ids = [];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      }
      this.selectTableData.forEach((item) => {
        ids.push(item.outgoingId);
      });
      this.$confirm("确定要批量过账吗? 请谨慎操作", "提示:")
        .then((res) => {
          this.$API.outgoingbatchPostingV5({ outgoingIds: ids }).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch((err) => {});
    },
    // 打印相关的

    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == "storage") {
          this.storageList = res || [];
        }
      }); //获取网点列表
    },
    // 承运商列表
    changeCarrier(e) {
      this.$COMAPI.changeCarrier(e).then((res) => {
        this.changeCarrierList = res || [];
      });
    },
    // 新增
    addBtns() {
      this.$router.push("/OutgoingManage/OutgoingAdd");
    },
    // 修改
    WaybillEdit(row, key) {
      this.$router.push({
        path: "/OutgoingManage/PendingOutboundEntry/SettlementEntry",
        query: {
          outgoingId: row.outgoingId,
        },
      });
    },
    //
    transportPlan() {
      // this.$router.push({
      //   path: "/WaybillManage/TransportationPlann",
      //   query: {
      //     id: 1,
      //   },
      // });
    },

    // 过账
    guoZhang(row) {
      this.$router.push({
        path: "/OutgoingManage/OutgoingPosting",
        query: {
          outgoingId: row.outgoingId,
          waybillNumber: row.waybillNumber,
        },
      });
    },
    // 反过账
    fanGuoZhang(row) {
      let ids = [];
      if (row) {
        ids.push(row.outgoingId);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要反过账的外发单");
          return false;
        }

        ids = this.selectTableData.map((item) => {
          return item.outgoingId;
        });
      }
      this.$confirm(
        "确定要把选择的外发单进行 反过账 操作吗? 请谨慎操作",
        "提示:"
      )
        .then(() => {
          this.$API.outgoingbatchBackPostingV5({ outgoingIds: ids }).then((res) => {
            this.$message.success(res.data.message || "");
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 删除外发单
    delBtns(row) {
      let ids = [];
      if (row) {
        ids.push(row.outgoingId);
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要删除的外发单");
          return false;
        }

        ids = this.selectTableData.map((item) => {
          return item.outgoingId;
        });
      }

      this.$confirm("确定要把选择的外发单进行 删除 操作吗? 请谨慎操作", "提示:")
        .then(() => {
          this.$API.wtl_delOutgoingBill({ outgoingIds: ids }).then((res) => {
            this.$message.success(res.data.message || "");
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 终止运单
    stopYd() {},
    // 合单
    heDan() {},

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.tableDataA = [];
      this.dialogForm = {
        // 弹窗表单数据
        onoType: "",
        numbers: [],
        confDictKey: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      // this.isShowDialog = false;
      let param = JSON.parse(JSON.stringify(this.dialogForm));
      this.$API
        .pullThirdApiPlatformData(param)
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.tableDataA = res.data.result.pullInfoVos || [];
        })
        .catch(() => {
          this.$message.error(res.data.message || "操作失败");
        });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
      this.tableDataA = [];
      this.dialogForm = {
        // 弹窗表单数据
        onoType: "",
        numbers: [],
        confDictKey: "",
      };
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 跳转运单详情
    goYdDetails(a) {
      // this.$message.success("你点我干嘛");
      this.$router.push({
        path: "/WaybillManage/WaybillDetails",
        query: {
          yd: "123",
        },
      });
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false;
      this.getData();
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
      this.documentNumbers = ""; //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row);
    },

    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: "/BusinessManagement/addPacks",
      });
    },

    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: "/BusinessManagement/addPacks",
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        });
      } else {
        this.$message.error("请选一个需要修改的包裹");
      }
    },

    PackageDetails() {
      //  包裹详情
      if (this.selectTableData.length > 0) {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
          query: {
            packageId: this.selectTableData[0].packageId,
            courierNumber: this.selectTableData[0].courierNumber,
          },
        });
      } else {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
        });
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            "chu_ku_zai_tu:package_status" ||
          this.selectTableData[0].packageStatus ==
            "ke_hu_qian_shou:package_status" ||
          this.selectTableData[0].packageStatus ==
            "chu_ku_zhong:package_status" ||
          this.selectTableData[0].packageStatus ==
            "da_bao_wan_cheng:package_status"
        ) {
          this.$router.push({
            path: "/BusinessManagement/dabaoDetails",
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          });
        } else {
          this.$message.error("包裹未打包完成");
        }
      } else {
        this.$message.error("请选择一个包裹");
      }
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dy_a") {
        // 打印标签
        this.isShowDialog_print = true;
      }
      if (a === "print_btn") {
        this.printEvent();
      }
      if (a === "jtdc") {
        // 新版导出
        this.isShowDialog_dc = true;
      }
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      if (type === "a") {
        // 合世版本
        // this.guoZhang(val);

        // 荣祥版本
        this.WaybillEdit(val, 2);
      }
      if (type === "b") {
        this.fanGuoZhang(val);
      }
      if (type === "c") {
        this.delBtns(val);
      }
    },
    // *************************打印模板 start *************************
    handleCloseClassNameDia() {
      this.isShowClassNameDialog = false;
    },
    classNameDiaCancelBtn() {
      this.isShowClassNameDialog = false;
    },
    classNameDiaConfirmBtn() {
      // modelClassName
      if (!this.modelClassName) {
        this.$message.error("请选择className");
        return;
      }
      this.isShowClassNameDialog = false;
      setTimeout(() => {
        this.dialogFrom.dialogVisible = false;
        this.printTitle = "创建模板";
        this.printType = 1;
        this.modelObj = null;
        setTimeout(() => {
          this.printForm.dialogVisible = true;
        }, 300);
      }, 300);
    },
    // 打印系统关闭
    handlePrintSysClose() {
      if (this.$refs.dialogSelect) {
        this.$refs.dialogSelect.doSearch();
      }
    },
    // 打印弹出框创建
    handleCreated() {
      this.isShowClassNameDialog = true;
    },
    // 打印预览模板
    handleEdit(obj) {
      // this.dialogFrom.dialogVisible = false;
      this.printTitle = obj.modelName;
      this.printType = 2;
      this.modelObj = obj;
      setTimeout(() => {
        this.printForm.dialogVisible = true;
      }, 300);
    },
    // 打印预览模板
    handleView(obj) {
      console.log("obj", obj);
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = [];
      for (let i = 0; i < this.selectTableData.length; i++) {
        idarr.push(this.selectTableData[i].waybillSplitId);
      }
      if (obj.className == this.modelClassName) {
        this.$API
          .getWaybillRxPrintData({
            waybillSplitIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },

    // 打印
    printEvent(row) {
      if (this.selectTableData.length < 1) {
        this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
          confirmButtonText: "新建模板",
          cancelButtonText: "关闭",
        }).then((res) => {
          if (res == "confirm") {
            this.handleCreated();
          } else {
            // this.$message.error("请选择需要打印的数据源");
            // return false;
          }
        });
      } else {
        let idarr = this.selectTableData.map((item) => {
          return item.waybillSplitId;
        });
        window.sessionStorage.setItem(
          "set_PrintSelectTableData",
          JSON.stringify(idarr)
        );
        this.dialogFrom.dialogVisible = true;
      }
    },
    addOutgoing() {
      this.$router.push({
        path: "/OutgoingManage/PendingOutboundEntry/addOutgoing",
        query:{
          t:1
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style>
